module.exports = __webpack_public_path__ + "img/APEX.02642cda.png";